import { z } from 'zod';

export const GetPoliciesRequestSchema = z.object({
  'id-in': z.string().optional(),
  limit: z.number().min(1).max(100).optional(),
  offset: z.number().min(0).optional(),
});

export type GetPoliciesRequest = z.infer<typeof GetPoliciesRequestSchema>;
